var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { DataKind, ExprTag, SortDirection, QueryChangePart, QueryChangeAction, Widget, WidgetGroup } from '@easyquery/core';
import { eqDragManager, DropEffect, getElementAbsolutePos, domel } from '@easydata/ui';
import { PopupMenu } from '../utils/popup_menu';
import { eqCssPrefix } from '../utils/utils';
import { browserUtils } from '../utils/browser_utils';
import { AggrFuncColumnRendererCB } from './renderers/columnsbar/aggrfunc_column_renderer';
import { SimpleColumnRendererCB } from './renderers/columnsbar/simple_column_renderer';
var ColumnsBar = /** @class */ (function (_super) {
    __extends(ColumnsBar, _super);
    function ColumnsBar(slot, customQuery) {
        var _this = _super.call(this, slot) || this;
        _this.options = {
            isSubQuery: false,
            activeColumn: null,
            showAddRow: true,
            showHeader: true,
            showColumnTitles: true,
            allowAggrColumns: true,
            allowDuplicates: true,
            allowCustomExpressions: false,
            allowSorting: true,
            attrElementFormat: '{entity} {attr}',
            titleElementFormat: null,
            alwaysShowButtons: false,
            accentActiveColumn: true,
            allowDragDrop: true,
            menuOptions: {
                showSearchBoxAfter: 30,
                searchBoxAutoFocus: true,
                activateOnMouseOver: true,
                adjustHeight: true,
                itemRenderedCallback: null
            },
            attrPlacement: 0,
            sortEntities: false,
            columnRenderedCallback: null,
            customExpressionText: 0,
        };
        _this.landingSlot = domel('div')
            .addClass(eqCssPrefix + "-highlight")
            .toDOM();
        _this.landingIndex = -1;
        _this.sortMenuList = [
            { id: 'None', text: i18n.getText('CmdNotSorted') },
            { id: 'Ascending', text: i18n.getText('CmdAscending') },
            { id: 'Descending', text: i18n.getText('CmdDescending') },
            { id: '---', text: '---' }
        ];
        _this.moveMenuList = [
            { id: 'MoveTop', text: i18n.getText('CmdMoveToFirst') },
            { id: 'MoveUp', text: i18n.getText('CmdMoveToPrev') },
            { id: 'MoveDown', text: i18n.getText('CmdMoveToNext') },
            { id: 'MoveBottom', text: i18n.getText('CmdMoveToLast') }
        ];
        domel(_this.slot)
            .addClass(_this.cssPrefix + "-panel")
            .addClass(browserUtils.getMobileCssClass());
        _this.group = WidgetGroup.Query;
        _this.customQuery = customQuery;
        return _this;
    }
    Object.defineProperty(ColumnsBar.prototype, "cssPrefix", {
        get: function () {
            return "eqjs-cb";
        },
        enumerable: true,
        configurable: true
    });
    ColumnsBar.prototype.getWidgetType = function () {
        return 'columnsBar';
    };
    ColumnsBar.prototype.init = function (context, options) {
        var _this = this;
        _super.prototype.init.call(this, context, options);
        this.setOptions(options);
        this.detachQueryObserver();
        this.attachQueryObserver();
        eqDragManager.removeDropContainer(this.slot);
        if (this.options.allowDragDrop) {
            eqDragManager.registerDropContainer({
                element: this.slot,
                scopes: ["entityAttrSort"],
                onDragEnter: function (container, ev) {
                    _this.showLandingSlot(ev.pageX, ev.pageY);
                },
                onDragOver: function (container, ev) {
                    _this.showLandingSlot(ev.pageX, ev.pageY);
                },
                onDragLeave: function (container, ev) {
                    ev.dropEffect = DropEffect.Forbid;
                    _this.hideLandingSlot();
                },
                onDrop: function (container, ev) {
                    var query = _this.getQuery();
                    var columns = query.getColumns();
                    var index = columns.indexOf(ev.data.column);
                    _this.moveColumnCore(index, _this.landingIndex);
                }
            });
        }
    };
    ColumnsBar.prototype.attachQueryObserver = function () {
        var _this = this;
        var query = this.getQuery();
        this.queryEventCallbackId = query.addChangedCallback(function (event) {
            //if something has changed, and that change is related to columns
            var edata = event.data;
            if (!edata || (edata.part != QueryChangePart.Columns
                && edata.part != QueryChangePart.Aggregation
                && edata.part != QueryChangePart.All)) {
                return;
            }
            var focusedBefore = document.activeElement;
            var isFocusInside = _this.slot.contains(focusedBefore) || focusedBefore == document.body;
            switch (edata.action) {
                case QueryChangeAction.Modify: {
                    var columns = edata.changee;
                    var modifyColumn_1 = function (column) {
                        var colEl = _this.columnsBlock.querySelector("div[data-id='" + column.id + "']");
                        if (colEl) {
                            var newEl = _this.renderColumn(column, colEl);
                            if (isFocusInside) {
                                var focusElem = newEl.querySelector('a');
                                if (focusElem) {
                                    focusElem.focus();
                                }
                            }
                        }
                    };
                    if (Array.isArray(columns)) {
                        columns.forEach(function (col) { return modifyColumn_1(col); });
                    }
                    else {
                        modifyColumn_1(columns);
                    }
                    break;
                }
                case QueryChangeAction.Add: {
                    var columns = edata.changee;
                    var addColumn_1 = function (column) {
                        var index = query.getColumns().indexOf(column);
                        _this.addColumnElement(column, index);
                    };
                    if (Array.isArray(columns)) {
                        columns.forEach(function (col) { return addColumn_1(col); });
                    }
                    else {
                        addColumn_1(columns);
                    }
                    break;
                }
                case QueryChangeAction.Delete: {
                    var columns = edata.changee;
                    var deleteColumn_1 = function (column) {
                        var colEl = _this.columnsBlock.querySelector("div[data-id='" + column.id + "']");
                        if (colEl) {
                            var next = colEl.nextSibling;
                            var prev = colEl.previousSibling;
                            _this.columnsBlock.removeChild(colEl);
                            if (isFocusInside) {
                                var focusCond = next || prev || _this.addRowButton;
                                var focusElem = focusCond.querySelector('a');
                                if (focusElem) {
                                    focusElem.focus();
                                }
                            }
                        }
                    };
                    if (Array.isArray(columns)) {
                        columns.forEach(function (col) { return deleteColumn_1(col); });
                    }
                    else {
                        deleteColumn_1(columns);
                    }
                    break;
                }
                default:
                    _this.refresh();
                    break;
            }
        });
    };
    ColumnsBar.prototype.getQuery = function () {
        return this.customQuery
            ? this.customQuery
            : this.getContext().getQuery();
    };
    ColumnsBar.prototype.destroyCore = function () {
        eqDragManager.removeDropContainer(this.slot);
        this.detachQueryObserver();
        this.slot.innerHTML = '';
    };
    ColumnsBar.prototype.detachQueryObserver = function () {
        if (this.queryEventCallbackId) {
            var query = this.getQuery();
            query.removeChangedCallback(this.queryEventCallbackId);
        }
    };
    ColumnsBar.prototype.setOptions = function (options) {
        this.options = dataUtils.assignDeep(this.options, options);
    };
    ColumnsBar.prototype.showLandingSlot = function (pageX, pageY) {
        var elements = this.columnsBlock.querySelectorAll("[class*=" + this.cssPrefix + "-row]");
        var columnSlots = [];
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].style.display !== 'none') {
                columnSlots.push(elements[i]);
            }
        }
        if (columnSlots.length === 0) {
            this.landingIndex = 0;
            return;
        }
        var landingPos = getElementAbsolutePos(this.landingSlot);
        if (pageX >= landingPos.x && pageX <= landingPos.x + this.landingSlot.offsetWidth
            && pageY >= landingPos.y && pageY <= landingPos.y + this.landingSlot.offsetHeight) {
            return;
        }
        var newLandingIndex = this.landingIndex;
        for (var i = 0; i < columnSlots.length; i++) {
            var colSlot = columnSlots[i];
            var absPos = getElementAbsolutePos(colSlot);
            var colWidth = colSlot.offsetWidth;
            var colHeight = colSlot.offsetHeight;
            var paddingWidth = 0.2 * colWidth;
            var paddingHeight = 2;
            if (pageX >= absPos.x + paddingWidth && pageX <= absPos.x + colWidth - paddingWidth
                && pageY >= absPos.y + paddingHeight && pageY <= absPos.y + colHeight - paddingHeight) {
                if (pageX > landingPos.x)
                    newLandingIndex = i + 1;
                else
                    newLandingIndex = i;
                break;
            }
        }
        if (newLandingIndex != this.landingIndex || this.landingSlot.parentElement) {
            this.landingIndex = newLandingIndex;
            if (this.landingIndex <= 0) {
                this.columnsBlock.insertBefore(this.landingSlot, columnSlots[0]);
            }
            if (this.landingIndex < columnSlots.length) {
                this.columnsBlock.insertBefore(this.landingSlot, columnSlots[this.landingIndex]);
            }
            else {
                this.columnsBlock.appendChild(this.landingSlot);
            }
        }
    };
    ColumnsBar.prototype.hideLandingSlot = function () {
        this.landingIndex = -1;
        if (this.landingSlot.parentElement) {
            this.landingSlot.parentElement.removeChild(this.landingSlot);
        }
    };
    ColumnsBar.prototype.onProcessStartCore = function () {
    };
    ColumnsBar.prototype.onProcessEndCore = function () {
    };
    ColumnsBar.prototype.refreshCore = function () {
        this.clear();
        this.render();
    };
    ColumnsBar.prototype.clear = function () {
        // if (this.addRowButton) {
        //     this.addRowButton.innerHTML = "";
        //     this.addRowButton.className = "";
        // }
        // this.columnsBlock.innerHTML = "";
        this.slot.innerHTML = '';
    };
    ColumnsBar.prototype.renderAddRowButton = function () {
        var _this = this;
        domel(this.addRowButton)
            .addClass(eqCssPrefix + "-addrow", this.cssPrefix + "-addrow", eqCssPrefix + "-addrow-empty")
            .addClass(browserUtils.getMobileCssClass())
            .title(i18n.getText('CmdClickToAddColumn'))
            .addChild('a', function (builder) { return builder
            .attr('href', 'javascript:void(0)')
            .on('click', function (e) {
            e.preventDefault();
            _this.showEntitiesMenu({
                anchor: e.target,
                selectedIds: null,
                itemSelectedCallback: function (data, items) {
                    var attrid = data.id;
                    _this.addNewColumn(attrid);
                    return false;
                }
            });
        }); });
        if (browserUtils.isMobileMode()) {
            domel(this.columnsBlock)
                .addChildElement(this.addRowButton);
        }
    };
    ColumnsBar.prototype.render = function () {
        var _this = this;
        this.createEntitiesMenu();
        if (this.options.allowSorting) {
            this.createSortMenu();
        }
        this.createMoveMenu();
        this.columnsBlock =
            domel('div')
                .addClass(this.cssPrefix + "-columns")
                .addClass(browserUtils.getMobileCssClass())
                .toDOM();
        if (this.options.showAddRow) {
            this.addRowButton =
                domel('div')
                    .toDOM();
            if (browserUtils.isMobileMode()) {
                domel(this.columnsBlock)
                    .addChildElement(this.addRowButton);
            }
            else {
                domel(this.slot)
                    .addChildElement(this.addRowButton);
            }
            this.renderAddRowButton();
        }
        domel(this.slot)
            .addChildElement(this.columnsBlock)
            .addChildElement(this.renderColumnButtonsBlockMobile());
        var query = this.getQuery();
        var columns = query.getColumns();
        columns.forEach(function (column, index) {
            var slot = _this.renderColumn(column);
            _this.columnsBlock.appendChild(slot);
        });
    };
    ColumnsBar.prototype.renderColumnButtonsBlockMobile = function () {
        var _this = this;
        this.columnButtonsBlockMobileArrow = domel('i').toDOM();
        this.columnButtonsBlockMobile = domel('div')
            .addClass(this.cssPrefix + "-column-buttonsBlock")
            .addClass(browserUtils.getMobileCssClass())
            .addChildElement(this.columnButtonsBlockMobileArrow)
            .hide()
            .toDOM();
        this.buttonsBlockSortingButton = domel('div', this.columnButtonsBlockMobile)
            .addClass(this.cssPrefix + "-column-button", this.cssPrefix + "-column-sortbutton-none")
            .toDOM();
        domel(this.buttonsBlockSortingButton)
            .on('touchstart click', function (ev) {
            ev.stopPropagation();
            _this.currentColumnRenderer.buttonSortingClickHandler.call(_this.currentColumnRenderer, ev, _this.buttonsBlockSortingButton);
            _this.toggleColumnPicked(null);
            _this.hideColumnButtonsMobile();
            return false;
        });
        this.buttonsBlockTypeButton = domel('div', this.columnButtonsBlockMobile)
            .addClass(this.cssPrefix + "-column-button", this.cssPrefix + "-column-button-type")
            .on('touchstart click', function (ev) {
            ev.stopPropagation();
            _this.currentColumnRenderer.buttonTypeClickHandler.call(_this.currentColumnRenderer, ev);
            _this.toggleColumnPicked(null);
            _this.hideColumnButtonsMobile();
            return false;
        })
            .toDOM();
        this.buttonsBlockFormatButton = domel('div', this.columnButtonsBlockMobile)
            .addClass(this.cssPrefix + "-column-button", this.cssPrefix + "-column-button-format")
            .on('touchstart click', function (ev) {
            ev.stopPropagation();
            _this.currentColumnRenderer.buttonFormatClickHandler.call(_this.currentColumnRenderer, ev);
            _this.toggleColumnPicked(null);
            _this.hideColumnButtonsMobile();
            return false;
        })
            .toDOM();
        this.buttonsBlockDeleteButton = domel('div', this.columnButtonsBlockMobile)
            .addClass(this.cssPrefix + "-column-button", this.cssPrefix + "-column-button-delete")
            .on('touchstart click', function (ev) {
            ev.stopPropagation();
            _this.currentColumnRenderer.buttonDeleteClickHandler.call(_this.currentColumnRenderer, ev);
            _this.toggleColumnPicked(null);
            _this.hideColumnButtonsMobile();
            return false;
        })
            .toDOM();
        domel('div', this.columnButtonsBlockMobile)
            .addClass(this.cssPrefix + "-column-button-close-block")
            .on('touchstart click', function () {
            _this.toggleColumnPicked(null);
            _this.hideColumnButtonsMobile();
        });
        return this.columnButtonsBlockMobile;
    };
    ColumnsBar.prototype.showColumnButtonsMobile = function (column, columnRenderer, columnElement) {
        this.currentActiveColumn = column;
        this.currentColumnRenderer = columnRenderer;
        //calculate coordinates
        var rect = columnElement.getBoundingClientRect();
        var top = columnElement.offsetTop;
        var left = columnElement.offsetLeft;
        domel(this.columnButtonsBlockMobileArrow)
            .setStyle('left', (left + rect.width / 2).toString() + 'px');
        if (rect.top > 100) {
            domel(this.columnButtonsBlockMobile)
                .removeClass('show-below')
                .setStyle('top', (top - rect.height).toString() + 'px');
        }
        else {
            domel(this.columnButtonsBlockMobile)
                .addClass('show-below')
                .setStyle('top', (top + rect.height).toString() + 'px');
        }
        //show/hide separate buttons
        if (column.enabled && !column.isReadOnly()) {
            domel(this.buttonsBlockSortingButton).show();
            domel(this.buttonsBlockTypeButton).show();
            if (columnRenderer.formatButtonIsShown()) {
                domel(this.buttonsBlockFormatButton).show();
            }
            else {
                domel(this.buttonsBlockFormatButton).hide();
            }
        }
        else {
            domel(this.buttonsBlockSortingButton).hide();
            domel(this.buttonsBlockTypeButton).hide();
        }
        //show
        if (column.isReadOnly()) {
            domel(this.columnButtonsBlockMobile).hide();
        }
        else {
            domel(this.columnButtonsBlockMobile).show();
        }
    };
    ColumnsBar.prototype.hideColumnButtonsMobile = function () {
        domel(this.columnButtonsBlockMobile).hide();
    };
    ColumnsBar.prototype.renderColumn = function (column, elem) {
        var _this = this;
        var renderer = this.getColumnRenderer(column, elem);
        if (renderer) {
            var columnSlot_1 = renderer.render();
            renderer.onShowButtonsMobile = function () {
                _this.showColumnButtonsMobile(column, renderer, columnSlot_1);
            };
            renderer.onHideButtonsMobile = function () {
                _this.hideColumnButtonsMobile();
            };
            return columnSlot_1;
        }
        return null;
    };
    ColumnsBar.prototype.getColumnRenderer = function (column, slot) {
        switch (column.expr.tag) {
            case ExprTag.AggregateFunction:
                return new AggrFuncColumnRendererCB(this, column, slot);
            case ExprTag.CustomSql:
            //                return new CustomSqlColumnRendererCB(this, column, slot);
            case ExprTag.EntityAttribute:
            case ExprTag.ParentEntityAttribute:
                return new SimpleColumnRendererCB(this, column, slot);
        }
        return null;
    };
    ColumnsBar.prototype.addNewColumn = function (attrId, index) {
        var _this = this;
        var model = this.getContext().getModel();
        var query = this.getQuery();
        var getColumnByAttrId = function (attrid) {
            var attribute = model.getAttributeById(attrid);
            if (!attribute) {
                return null;
            }
            if (!attribute.useInResult) {
                if (attribute.lookupAttr) {
                    attrid = attribute.lookupAttr;
                    attribute = model.getAttributeById(attrid);
                    if (!attribute || !attribute.useInResult) {
                        return null;
                    }
                }
                else
                    return null;
            }
            var column = query.createColumn();
            column.caption = _this.getDefaultColumnCaption(attribute);
            column.sorting = SortDirection.None;
            column.sortIndex = -1;
            column.expr.tag = ExprTag.EntityAttribute;
            column.expr.kind = DataKind.Attribute;
            column.expr.dataType = attribute.dataType;
            column.expr.setValue(attrid, true);
            column.params.concat(attribute.params);
            return column;
        };
        if (!this.getQuery()) {
            return;
        }
        var colToAdd, col;
        if (Array.isArray(attrId)) {
            colToAdd = [];
            for (var i = 0; i < attrId.length; i++) {
                col = getColumnByAttrId(attrId[i]);
                if (col) {
                    colToAdd.push(col);
                }
            }
        }
        else
            colToAdd = getColumnByAttrId(attrId);
        this.addColumn(colToAdd, index);
        return colToAdd;
    };
    ColumnsBar.prototype.toggleColumnPicked = function (column) {
        var el;
        var isActive;
        if (column) {
            el = this.columnsBlock.querySelector("div[data-id=" + column.id + "]");
            if (el) {
                isActive = el.classList.contains('active');
            }
        }
        //clear 'active' in all rows
        var rows = this.columnsBlock.querySelectorAll("." + this.cssPrefix + "-row");
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            domel(row)
                .removeClass('active')
                .data("show-buttons", null);
        }
        if (el && !isActive) {
            domel(el)
                .addClass('active')
                .data("show-buttons", "");
        }
    };
    ColumnsBar.prototype.addColumn = function (column, index) {
        var query = this.getQuery();
        if (!query) {
            return;
        }
        if (Array.isArray(column))
            column = this.checkColumnsArray(column);
        else
            column = this.checkColumn(column);
        if (!column || (Array.isArray(column) && column.length == 0)) {
            return;
        }
        query.addColumnObj(column, index, self);
        query.fireChangedEvent({
            part: QueryChangePart.Columns,
            action: QueryChangeAction.Add,
            changee: column
        });
    };
    //adds one column to the bar on the specified position
    ColumnsBar.prototype.addColumnElement = function (column, index) {
        var rows = this.columnsBlock.querySelectorAll("[class*=" + this.cssPrefix + "-row]");
        var newColBlock = this.renderColumn(column);
        if (rows.length > 0) {
            if (index < rows.length - 1) {
                this.columnsBlock.insertBefore(newColBlock, rows[index]);
            }
            else {
                this.columnsBlock.appendChild(newColBlock);
            }
        }
        else {
            this.columnsBlock.appendChild(newColBlock);
        }
        if (this.options.columnRenderedCallback) {
            this.options.columnRenderedCallback(newColBlock);
        }
    };
    ColumnsBar.prototype.checkColumnsArray = function (cols) {
        var i = 0, len = cols.length;
        var result = [];
        for (var i_1 = 0; i_1 < len; i_1++) {
            if (this.checkColumn(cols[i_1]))
                result.push(cols[i_1]);
        }
        return result;
    };
    ColumnsBar.prototype.checkColumn = function (col) {
        if (!this.options.allowDuplicates) {
            var query = this.getQuery();
            var columns = query.getColumns();
            var colJson = JSON.stringify(col.expr);
            for (var i = 0; i < columns.length; i++) {
                var qcolJson = JSON.stringify(columns[i].expr);
                if (qcolJson === colJson) {
                    return null;
                }
            }
        }
        return col;
    };
    ColumnsBar.prototype.getDefaultColumnCaption = function (attr) {
        var format = this.options.titleElementFormat || this.options.attrElementFormat;
        var model = this.getContext().getModel();
        return model.getAttributeText(attr, format);
    };
    ColumnsBar.prototype.getColumnsBlock = function () {
        return this.columnsBlock;
    };
    ColumnsBar.prototype.showEntitiesMenu = function (menuOptions) {
        this.entitiesMenu && this.entitiesMenu.showMenu(menuOptions);
    };
    ColumnsBar.prototype.createEntitiesMenu = function () {
        var model = this.getContext().getModel();
        if (!model || model.isEmpty())
            return null;
        var menuId = this.slot.id;
        if (menuId) {
            menuId += '-EntitiesMenu';
        }
        var entitiesList = model.getEntitiesTree({ addUIC: false, addUIR: true, addUIS: false, attrPlacement: this.options.attrPlacement, sortEntities: this.options.sortEntities });
        var options = { items: entitiesList, adjustHeight: this.options.adjustEntitiesMenuHeight, id: menuId, domWriteItemsId: this.options.domWriteItemsId };
        dataUtils.assign(options, this.options.menuOptions);
        this.entitiesMenu = new PopupMenu(options);
    };
    ColumnsBar.prototype.createSortMenu = function () {
        var model = this.getContext().getModel();
        if (!model || model.isEmpty())
            return null;
        var menuId = this.slot.id;
        if (menuId) {
            menuId += '-SortMenu';
        }
        var items = this.sortMenuList.concat(this.moveMenuList);
        var menuOptions = { "items": items, id: menuId, domWriteItemsId: this.options.domWriteItemsId };
        dataUtils.assign(menuOptions, this.options.menuOptions);
        menuOptions.searchBoxAlwaysShown = false;
        this.sortMenu = new PopupMenu(menuOptions);
    };
    ColumnsBar.prototype.createMoveMenu = function () {
        var model = this.getContext().getModel();
        if (!model || model.isEmpty())
            return null;
        var menuId = this.slot.id;
        if (menuId) {
            menuId += '-MoveMenu';
        }
        var items = this.moveMenuList;
        var menuOptions = { "items": items, id: menuId, domWriteItemsId: this.options.domWriteItemsId };
        dataUtils.assign(menuOptions, this.options.menuOptions);
        this.moveMenu = new PopupMenu(menuOptions);
        menuOptions.searchBoxAlwaysShown = false;
    };
    ColumnsBar.prototype.moveColumn = function (column, direction) {
        var query = this.getQuery();
        var columns = query.getColumns();
        var index = columns.indexOf(column);
        if (index >= 0) {
            switch (direction) {
                case 'MoveTop':
                    if (index == 0) {
                        return;
                    }
                    this.moveColumnCore(index, 0);
                    break;
                case 'MoveUp':
                    if (index == 0) {
                        return;
                    }
                    this.moveColumnCore(index, index - 1);
                    break;
                case 'MoveDown':
                    if (index == columns.length - 1) {
                        return;
                    }
                    this.moveColumnCore(index, index + 1);
                    break;
                case 'MoveBottom':
                    if (index == columns.length - 1) {
                        return;
                    }
                    this.moveColumnCore(index, columns.length - 1);
                    break;
            }
            ;
        }
    };
    ColumnsBar.prototype.moveColumnCore = function (index1, index2) {
        var query = this.getQuery();
        if (!query)
            return;
        var rows = this.columnsBlock.querySelectorAll("[class*=" + this.cssPrefix + "-row]");
        var colToMove = rows[index1];
        if (index2 <= 0) {
            this.columnsBlock.insertBefore(colToMove, this.columnsBlock[0]);
        }
        else if (index2 < rows.length) {
            this.columnsBlock.insertBefore(colToMove, rows[index2]);
        }
        else {
            this.columnsBlock.appendChild(colToMove);
        }
        query.moveColumn(index1, index2);
        query.fireColumnsChangedEvent(QueryChangeAction.All);
    };
    ColumnsBar.prototype.areCustomExpressionsAllowed = function () {
        var query = this.getQuery();
        return query.isEx() && this.options.allowCustomExpressions;
    };
    ColumnsBar.globalCounter = 0;
    return ColumnsBar;
}(Widget));
export { ColumnsBar };
//# sourceMappingURL=columns_bar.js.map